import React, { useState, useEffect, useRef } from 'react';
import Menu from "./menu";
import styled from "styled-components";
import Footer from "./footer";
import Modal from 'react-modal';
import apiService from '../../services/apiService';
import CustomToast from '../Toast';
import '../../custom.css';


const Navbar = ({ children, isOrganisationDetails, showSidebar = true }) => {
    const videoRef = useRef(null);
    const [show, setShow] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const [isModalOpen, setModalOpen] = useState(false);
    const [userData, setUserData] = useState(false);
    const [error, setError] = useState('');
    const [adminRole, setAdminRole] = useState(localStorage.getItem('adminRole') || '');
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const [SidebarData, setSidebarData] = useState([]);
    const [icSidebarData, setIcSidebarData] = useState([]);
    let orgInfo = JSON.parse(localStorage.getItem("orgInfo"));
    const fetchData = async () => {
        try {
            const token = apiService.getAuthToken()
            const result = await apiService.get('get-org-user-info', token);
            if (result && result.status == "success") {
                if (!adminRole) {
                    if (result.data.orgIcType === 'ic') {
                        localStorage.setItem('adminRole', 'ic-dash');
                        setAdminRole('ic-dash');
                    } else {
                        localStorage.setItem('adminRole', 'org-dash');
                        setAdminRole('org-dash');
                    }
                }
                localStorage.setItem("user_details", JSON.stringify(result.data));
                setUserData(result.data);
            }
        } catch (error) {
            setError('Error fetching user data');
            console.error(error);
        }
    };
    useEffect(() => {
        window.scrollTo(0, 0);
        fetchData();
        fetchMenuListList();
        const checkSession = async () => {
            try {
                const token = apiService.getAuthToken()
                const response = await apiService.get('check-user-session', token);
                if (response && response?.status === 'failed' || response?.message == 'Invalid token id!') {
                    CustomToast.info('Your session has expired due to inactivity. Please log in again to continue.');
                    window.location.href = process.env.REACT_APP_LOGIN_URL;
                }
            } catch (error) {
                if (error?.message == 'Invalid token id!') {
                    CustomToast.info('Your session has expired due to inactivity. Please log in again to continue.');
                    window.location.href = process.env.REACT_APP_LOGIN_URL
                }
            }
        };
        checkSession();
    }, []);

    const openVideoModal = () => {
        setModalOpen(true);
    };

    const closeVideoModal = () => {
        setModalOpen(false);
    };

    const showSideBar = () => {
        setShow(!show);
    }

    const handlePlay = () => {
        setIsVideoPlaying(true);
    };

    const handlePause = () => {
        setIsVideoPlaying(false);
        if (videoRef.current) {
            videoRef.current.pause();
        }
    };

    const handleEnded = () => {
        setIsVideoPlaying(false);
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem("selectedCourseObj")
        localStorage.removeItem("selectedCourse")
        localStorage.removeItem("orgData")
        sessionStorage.removeItem("userDetail")
        localStorage.removeItem("ORGID")
        localStorage.removeItem("user_details")
        localStorage.removeItem("inviteCourseList")
        localStorage.removeItem("image")
        localStorage.removeItem("inviteData")
        localStorage.removeItem("selectedLanguageInfo")
        localStorage.removeItem("CourseLanguagesData");
        localStorage.removeItem("preSelectedCourseObj");
        localStorage.removeItem("adminRole");
        window.location.href = process.env.REACT_APP_LOGIN_URL
    };


    const fetchMenuListList = () => {
        const token = apiService.getAuthToken()
        const plan_id = orgInfo?.plan_id || 'plan_122342567823';
        apiService.get(`get-menu-list-by-plans?planId=${plan_id}`, token).then(
            (response) => {
                setSidebarData(response.data[0].orgMenu || []);
                setIcSidebarData(response.data[1].icMenu || []);
                console.log("SidebarData", SidebarData);
                console.log("icSidebarData", icSidebarData);
            },
            (error) => {
                console.error("Error fetching data", error);
            }
        );
    };

    useEffect(() => {
        const handleScroll = () => {
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <header className={`header ${show ? "add_body_padding" : ""}  `} id="admin-dash-header">
                {(
                    adminRole !== 'org-dash' && (userData.orgIcType === 'ic' || userData.orgIcType === 'both')) ? (
                    <a href='/learning_space'> <img src="/images/logo.svg" alt="logo" className="navbar_logo" /></a>
                ) : <a href='/dashboard'> <img src="/images/logo.svg" alt="logo" className="navbar_logo" /></a>}
                <div className='header_toggle'>
                    <i id="header-toggle"></i>
                </div>
                <div className="dropdown sidebar-profile d-flex align-items-center justify-content-end">
                    <div className="language-picker">
                        <form action="" className="language-picker__form">
                            <select
                                id="language-picker"
                                name="language-picker"
                                className='form-control custom-select'
                                value={selectedLanguage}
                                onChange={(e) => setSelectedLanguage(e.target.value)}>
                                <option lang="" value="english">ENG</option>
                            </select>
                        </form>
                    </div>
                    <p className='username mb-0 ms-3'>Hello, {userData.name}</p>
                    <div className='dropdown-toggle position-relative' id="dropdownUser3" data-bs-toggle="dropdown" aria-expanded="false">
                        <a className="d-flex align-items-center justify-content-center p-2 link-dark text-decoration-none" >
                            <svg
                                fill="#000000"
                                height="15px"
                                width="15px"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 330 330"
                                xmlSpace="preserve"
                            >
                                <path
                                    id="XMLID_225_"
                                    d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                                />
                            </svg>
                        </a>
                        <ul className="dropdown-menu text-small mt-3 shadow" aria-labelledby="dropdownUser3">
                            <li>
                                <button className="dropdown-item" onClick={() => window.location.href = '/my_profile'}>
                                    My Profile
                                </button>
                            </li>
                            <li>
                                <button className="dropdown-item" onClick={handleLogout}>Logout</button>
                            </li>
                        </ul>
                    </div>

                    {orgInfo && orgInfo?.org_image ? <div className="admin-logo d-flex justify-content-center align-items-center" style={{ maxWidth: 350, maxHeight: 80 }}>
                        <img src={orgInfo?.org_image} className="img-fluid w-100" style={{ maxWidth: 150, maxHeight: 80, objectFit: "contain" }} /> </div> : null}
                </div>
            </header>
            <div className='wrapper'>
                {/* {showSidebar && (
                    <aside className={`sidebar pe-0 ${show ? "review" : ""} `} style={{ background: '#146B90' }} id="admin-dash-nav">
                        <div className='d-flex flex-column justify-content-between' style={{ minHeight: '100vh' }}>
                            <div className='sidebar-menu'>
                                {SidebarData?.filter(item => !['Micro Modules','Template Library', 'FAQ', 'Compliance'].includes(item.title)).map((item, index) => {
                                    return <Menu item={item} key={index} />;
                                })}
                                {SidebarData?.filter(item => item.title === 'Compliance').flatMap(item => item.subNav || []).filter(subItem => subItem.title === 'POSH Policy').map((subItem, index) => {
                                    return <Menu item={{ ...subItem, subNav: null, is_display: true }} key={`posh-${index}`} />;
                                })}
                            </div>

                            <div className='sticky-btn text-left'>
                                <button onClick={openVideoModal} className='btn btn-secondary p-2 w-100'>Watch Tutorial</button>
                            </div>

                            <Modal
                                isOpen={isModalOpen}
                                onRequestClose={closeVideoModal}
                                contentLabel="Video Modal"
                                className='videoModal w-75'
                            > <button type="button" className="close text-white" onClick={closeVideoModal}> <svg width="20" height="20" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                                <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                            </svg></button>
                                <video ref={videoRef} className="w-100" controls controlsList="nodownload" autoPlay
                                    onPlay={handlePlay}
                                    onPause={handlePause}
                                    onEnded={handleEnded}
                                    muted>
                                    <source src="https://inclusional.s3.ap-south-1.amazonaws.com/project_dev/project_dev/videos/2024-02-06 12:37:30-VID-20240123-WA0001.mp4" type="video/mp4" />
                                </video>
                            </Modal>

                        </div>
                    </aside>
                )} */}

                {
                    (showSidebar ?
                        (adminRole !== 'org-dash' && (userData.orgIcType === 'ic' || userData.orgIcType === 'both')) ? (
                            <aside className={`sidebar ${show ? "review" : ""}`} id="admin-dash-nav" style={{ background: "#156B90" }}>
                                {userData.orgIcType == 'both' && (
                                    <div className='mb-3 px-4'>
                                        <button
                                            onClick={() => {
                                                localStorage.setItem('adminRole', 'org-dash');
                                                window.location.href = '/dashboard';
                                            }}
                                            className="btn btn-primary watch-btn"
                                        >
                                            Switch to Admin Role
                                        </button>
                                    </div>
                                )}
                                <div className='d-flex flex-column justify-content-between' style={{ minHeight: '100vh' }}>
                                    <div className='sidebar-menu'>
                                        {icSidebarData?.filter(item => !['View Users', 'Case Studies', 'Micro Modules', 'Template Library', 'FAQ', 'Compliance'].includes(item.title)).map((item, index) => {

                                            return <Menu item={item} key={index} />;
                                        })}
                                        {icSidebarData?.filter(item => item.title === 'Compliance').flatMap(item => item.subNav || []).filter(subItem => subItem.title === 'POSH Policy').map((subItem, index) => {
                                            return <Menu item={{ ...subItem, subNav: null, is_display: true }} key={`posh-ic-${index}`} />;
                                        })}
                                    </div>
                                    {/* <div className='sticky-btn text-left'>
                                        <div className="mb-0" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                            <div
                                                className="watch-tutorial-btn" custom-box
                                                onClick={openVideoModal}
                                            >
                                                <span style={{ fontSize: '17px', textAlign: 'center', padding: "6px" }}>Watch Tutorial</span>
                                                <div
                                                    className='custom-box'
                                                >
                                                    <img
                                                        src="/images/play_circle.svg"
                                                        alt="Play Icon"
                                                        style={{ width: '20px', height: '20px' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <Modal
                                        isOpen={isModalOpen}
                                        onRequestClose={closeVideoModal}
                                        contentLabel="Video Modal"
                                        className='videoModal w-75'
                                    > <button type="button" className="close text-white" onClick={closeVideoModal}> <svg width="20" height="20" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                                        <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                                    </svg></button>
                                        {/* <video ref={videoRef} autoPlay
                                            className="w-100"
                                            controls
                                            controlsList="nodownload"
                                            onPlay={handlePlay}
                                            onPause={handlePause}
                                            onEnded={handleEnded}
                                        >
                                            <source src="https://www.youtube.com/watch?v=WDgsrTPFBes" type="video/mp4" />
                                        </video> */}
                                        <iframe
                                            width="100%"
                                            height="700"
                                            src="https://www.youtube.com/embed/WDgsrTPFBes"
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </Modal>
                                </div>
                            </aside> 
                        ) : (
                            <aside className={`sidebar ${show ? "review" : ""} `} id="admin-dash-nav" style={{ background: "#156B90" }}>
                                {/* {userData.orgIcType == 'both' && (
                                    <div className='mb-3 px-4'>
                                        <button
                                            onClick={() => {
                                                localStorage.setItem('adminRole', 'ic-dash');
                                                window.location.href = '/learning_space';
                                            }}
                                            className="btn btn-primary watch-btn"
                                        >
                                            Switch to IC Role
                                        </button>
                                    </div>
                                )} */}
                                <div className='d-flex flex-column justify-content-between' style={{ minHeight: '100vh' }}>
                                    <div className='sidebar-menu'>
                                        {SidebarData.filter(item => !['Micro Modules', 'Template Library', 'FAQ', 'Compliance'].includes(item.title)).map((item, index) => {
                                            return <Menu item={item} key={index} />;
                                        })}
                                        {SidebarData.filter(item => item.title === 'Compliance').flatMap(item => item.subNav || []).filter(subItem => subItem.title === 'POSH Policy').map((subItem, index) => {
                                            return <Menu item={{ ...subItem, subNav: null, is_display: true, icon: '/images/compliance-icon-1.svg' }} key={`posh-org-${index}`} />;
                                        })}
                                    </div>
                                    <div className='sticky-btn text-left'>
                                        <div className="mb-4" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                            <div
                                                className="watch-tutorial-btn" custom-box
                                                onClick={openVideoModal}
                                            >
                                                <span style={{ fontSize: '17px', textAlign: 'center', padding: "6px" }}>Watch Tutorial</span>
                                                <div
                                                    className='custom-box'
                                                >
                                                    <img
                                                        src="/images/play_circle.svg"
                                                        alt="Play Icon"
                                                        style={{ width: '20px', height: '20px' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                        <Modal
                                            isOpen={isModalOpen}
                                            onRequestClose={closeVideoModal}
                                            contentLabel="Video Modal"
                                            className='videoModal w-75'
                                        > <button type="button" className="close text-white" onClick={closeVideoModal}> <svg width="20" height="20" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                                            <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                                        </svg></button>
                                            {/* <video ref={videoRef}
                                            autoPlay
                                            className="w-100"
                                            controls
                                            controlsList="nodownload"
                                            onPlay={handlePlay}
                                            onPause={handlePause}
                                            onEnded={handleEnded}
                                        >
                                            <source src="https://inclusional.s3.ap-south-1.amazonaws.com/project_dev/project_dev/videos/2024-02-06 12:37:30-VID-20240123-WA0001.mp4" type="video/mp4" />
                                        </video> */}
                                            <iframe
                                                width="100%"
                                                height="700"
                                                src="https://www.youtube.com/embed/WDgsrTPFBes"
                                                title="YouTube video player"
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            ></iframe>
                                        </Modal>
                                </div>
                            </aside>
                        ) : '')
                }
                <main className={` ${show ? "add_body_padding" : "main"} `}>
                    {children}
                </main>
            </div>
            {/* <Footer></Footer> */}
        </>
    );
}

export default Navbar;
